import { Versions } from './AboutModal.types';

export const TDC_ABOUT_MODAL_SHOW = 'TDC_ABOUT_MODAL_SHOW';
export const TDC_ABOUT_MODAL_CLOSE = 'TDC_ABOUT_MODAL_CLOSE';
export const TDC_ABOUT_MODAL_SET_SERVICES = 'TDC_ABOUT_MODAL_SET_SERVICES';
export const TDC_ABOUT_FETCH_SERVICES = 'TDC_ABOUT_FETCH_SERVICES';

export function showAboutModal() {
	return {
		type: TDC_ABOUT_MODAL_SHOW,
	};
}

export function fetchServices() {
	return {
		type: TDC_ABOUT_FETCH_SERVICES,
	};
}

export function setAboutModalServices(services: Versions) {
	return {
		type: TDC_ABOUT_MODAL_SET_SERVICES,
		services,
	};
}

export function closeAboutModal() {
	return {
		type: TDC_ABOUT_MODAL_CLOSE,
	};
}

export default {
	'tdc:showAboutModal': showAboutModal,
	'tdc:setAboutModalServices': setAboutModalServices,
	'tdc:closeAboutModal': closeAboutModal,
};
